var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-select", {
    class: { "select-size-sm": _vm.small },
    style: { width: "90px" },
    attrs: {
      value: _vm.optionSelected,
      options: _vm.list,
      disabled: _vm.isDisabled,
      clearable: false
    },
    on: { input: _vm.onInput }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }